const pushWindowHistory = (paramToSetKey, paramToSetValue) => {
  const { origin, pathname, search } = window.location
  const searchParams = new URLSearchParams(search)

  if (paramToSetValue) {
    searchParams.set(paramToSetKey, paramToSetValue)
  } else {
    searchParams.delete(paramToSetKey)
  }

  const currentUrl = new URL(`${origin}${pathname}`)
  currentUrl.search = searchParams.toString()
  const path = currentUrl.href
  window.history.pushState({ path }, '', path)
}

export { pushWindowHistory }
